
const digest = 'ce52c1bc3312aebe882d076ddb09557f18061d201fd3112ac6e35c662f13a2c0';
const classes = {"container":"_container_1f7s9_1","number":"_number_1f7s9_7"};
const css = `._container_1f7s9_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
}

._number_1f7s9_7 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  